import React, { useEffect, useRef, useState, useContext } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Theme } from '@mui/material';
import "../css/receivefunds.css"
import { Scrollbars } from 'react-custom-scrollbars';
import CurrencyInput from 'react-currency-input-field';
import {FirebaseContext} from "../../../context/firebase";



const useStyles = makeStyles((theme: Theme)=>{
    return {
        navIcon: {
            color: '#999 !important',
            fontSize: '1.7rem !important',
            fontWeight: '900 !important'
        },
        logo: {
            transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
            margin:'0 auto'
        },
        logoHolder: {
          width: '100%',
          display: 'flex',
          justifyContent:'center',
          alignItems: 'center'
        },
        paragraph: {
          lineHeight: 1.6,
          color: '#555',
          fontSize: '0.978rem',
          fontStyle: 'normal',
          textAlign: 'left',
          fontWeight: '400',
          marginBottom: '30px'
      },
      footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '1rem',
        [theme.breakpoints.down('md')]: {
          padding: '0rem',
        },
      },
      linkButton: {
        color: '#fff !important',
        backgroundColor: '#5d307f',
        borderColor: '#5d307f',
        marginLeft: '10px',
        display: 'inline-block',
        fontWeight: 400,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        border: '1px solid transparent',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '0.25rem',
        textDecoration: 'none',
        transition: 'all 0.15s ease-in-out',

        "&:hover": {
          color: '#000 !important',
          backgroundColor: '#e37927',
          borderColor: '#e37927',
        },

        [theme.breakpoints.down('sm')]: {
          marginLeft: '0',
          marginTop: '5px',
          display: 'block'
        },
      },
      asideInner: {
        padding: '1rem',
        width: '100%',
        height: '100%',

        [theme.breakpoints.down('md')]: {
          padding: '1rem',
        },
      }
    }
})


interface Props{
    handleLimitTransactionClose: ()=> void
    handleEnterPinOpen: ()=> void
}

const LimitTranscation: React.FC<Props> = ({handleLimitTransactionClose, handleEnterPinOpen}) => {
  const { data, error, refresh } = useContext(FirebaseContext);
    
  const classes = useStyles()
  const [minValue, setMinValue] = useState('500000')
  const [maxValue, setMaxValue] = useState('5000000')
  const [minMaxBool, setMinMaxBool] = useState(false)


  useEffect(()=>{
    if(Number(maxValue) < 1 || Number(minValue) < 1 || !maxValue || !minValue){
        setMinMaxBool(true)
    }else{
        setMinMaxBool(false)
    }
  }, [minValue, maxValue])


  const [title, setTitle] = useState('ECCU to ECCU')
  const handleSwitchBank = (id: string , otherID: string) =>{
    document.getElementById(id)?.classList.add('active')
    document.getElementById(otherID)?.classList.remove('active')
    if(id === 'custom-large-badge-limit-trasacation-id-1'){
        setTitle('ECCU to ECCU')
    }else{
        setTitle('ECCU to Other Banks')
    }

  }

  return (
    <div id='sidebar-wrapper-limit-transacation' className='sidebar-wrapper-receive-funds'>
        
        <div className='sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable modal-dialog-420-important'>
            <aside className='sidebar-receive-funds-beneficiaries' style={{padding: '0 0.6rem'}}>
                
            <div className='limit-transaction-header'>
              <h6 className="limit-transaction-header-h6">{title}</h6>
            </div>


            <div className='funds-beneficiaries-body'>
              <div style={{margin: '1rem 0'}}>




                <div style={{marginBottom: '3rem', height: '330px'}}>
                  <div style={{position: 'relative', overflow: 'hidden'}}>
                    <Scrollbars 
                      style={{transform: 'translateZ(-100px)', height: '340px'}}
                      autoHide
                      autoHideTimeout={1000}
                      autoHideDuration={200}>
                        
                        <div style={{marginBottom: '1.4rem'}}>
                            <label className='custom-large-badge-limit-trasacation-label'>Account Type</label>

                            <div className="limit-transaction-past-wrapper">
                                <div role="button" id='custom-large-badge-limit-trasacation-id-1' className="custom-large-badge-limit-trasacation active" onClick={()=> handleSwitchBank('custom-large-badge-limit-trasacation-id-1', 'custom-large-badge-limit-trasacation-id-2')}>ECCU</div>
                                <div role="button" id='custom-large-badge-limit-trasacation-id-2' className="custom-large-badge-limit-trasacation" onClick={()=> handleSwitchBank('custom-large-badge-limit-trasacation-id-2', 'custom-large-badge-limit-trasacation-id-1')}>Other Banks</div>
                            </div>
                        </div>


                        <div style={{marginBottom: '1.4rem'}}>
                            <label className='custom-large-badge-limit-trasacation-label'>Bullet Limit ($)</label>

                            <div style={{marginBottom: '10px'}}>
                                <CurrencyInput 
                                    id='desiredloadamount'
                                    name="desiredloadamount" 
                                    decimalsLimit={2} 
                                    className='limit-trasacation-search'
                                    defaultValue={data.bulletLimit}
                                    onValueChange={(value, name, values) => setMinValue(value!)}
                                />
                                {/* <input type="text" className='limit-trasacation-search' /> */}
                            </div>
                        </div>

                        <div style={{marginBottom: '1.4rem'}}>
                            <label className='custom-large-badge-limit-trasacation-label'>Daily Limit ($)</label>

                            <div style={{marginBottom: '10px'}}>
                                <CurrencyInput 
                                    id='desiredloadamount'
                                    name="desiredloadamount" 
                                    decimalsLimit={2} 
                                    className='limit-trasacation-search'
                                    defaultValue={data.dailyLimit}
                                    onValueChange={(value, name, values) => setMaxValue(value!)}
                                />
                            </div>
                        </div>


                        <div className="limit-transaction-past-wrapper">
                            <button type="button" className="btn groom-panel-2-content-text-btn-limit-transaction1" onClick={handleLimitTransactionClose}>Cancel</button>
                            <button type="button" className="btn groom-panel-2-content-text-btn-limit-transaction2" disabled={minMaxBool} style={{opacity: `${ minMaxBool ? '0.5' : '1' }`}} onClick={handleEnterPinOpen}>Proceed</button>
                        </div>

                      </Scrollbars>
                  </div>
                </div>
              </div>
            </div>





                
            </aside>
        </div>
    </div>
  )
}

export default LimitTranscation
